<div class="upload-container">
  @if (formControlContext.pendingJobs$.value.length) {
    <div class="upload-list">
      @for (job of formControlContext.pendingJobs$.value; track job.attachment) {
        <wr-attachment-upload-entry [attachment]="job.attachment"
                                    (delete)="cancelJob(job)">
        </wr-attachment-upload-entry>
      }
    </div>
  }
  <wr-attachment-drop-zone [type]="type"
                           (fileSelected)="upload($event)">
  </wr-attachment-drop-zone>
</div>
